import React from 'react'
import { Route, NavLink, Switch, withRouter, Link, Redirect } from 'react-router-dom'
import {isLogin, login, logout} from '../../utils/index'

import Home from '../Home';
import Signin from '../Signin';

class UnauthorizedLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        menu:[],
    }   
  }

  handleLogout(){
    logout();
    this.props.history.push('/signin');
  }

  render() {
    
    return (
      <>
          <Switch>
                <Route exact path="/" component={Home}/>
                <Route path="/signin" component={Signin}/>
                {/* <Route exact path="/fabricqc/:id" component={FabricQC}/> */}
                {/* <Route path="/404" component={ErrorPage404} />
                <Route path="/500" component={ErrorPage500} /> */}
                {/* <Redirect to="/" /> */}
            </Switch>
      </>

    );
  }
}

export default UnauthorizedLayout;
